import { useEffect, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const SIZES = [
  { scale: 1, label: "Default", hint: "A" },
  { scale: 1.125, label: "Large", hint: "A+" },
  { scale: 1.25, label: "Largest", hint: "A++" },
];

const readScale = () => {
  try {
    const v = parseFloat(localStorage.getItem("nox_textscale"));
    return SIZES.some((s) => s.scale === v) ? v : 1;
  } catch {
    return 1;
  }
};

const TextSizeControl = ({ testId = "textsize-btn" }) => {
  const [scale, setScale] = useState(readScale);

  useEffect(() => {
    document.documentElement.style.fontSize = scale === 1 ? "" : `${16 * scale}px`;
    try {
      localStorage.setItem("nox_textscale", String(scale));
    } catch {}
  }, [scale]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="flex cursor-pointer items-center gap-1.5 border border-line px-2.5 py-1.5 font-jmono text-xs text-slate-400 transition-colors duration-300 hover:border-gold/50 hover:text-gold"
        aria-label="Adjust text size"
        data-testid={testId}
      >
        Aa
        {scale !== 1 && <span className="text-[8px] text-gold" aria-hidden="true">●</span>}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="border-line bg-[#0d0d12]" data-testid={`${testId}-menu`}>
        {SIZES.map((s) => (
          <DropdownMenuItem
            key={s.scale}
            onClick={() => setScale(s.scale)}
            data-testid={`${testId}-${s.label.toLowerCase()}`}
            className={`cursor-pointer gap-3 font-jmono text-[11px] tracking-[0.2em] ${
              s.scale === scale ? "text-gold" : "text-slate-400"
            }`}
          >
            <span className="w-10 text-left">{s.hint}</span>
            {s.label}
            {s.scale === scale && (
              <span className="ml-auto text-gold" aria-hidden="true">
                ✦
              </span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TextSizeControl;
